export default {
	title: 'Equipment Check Report',
	selectAll: 'Select All',
	selectedCount: 'Selected {count} item(s)',
	batchDelete: 'Batch Delete',
	batchDeleteWithCount: 'Batch Delete ({count})',
	sendEmail: 'Send Email',
	sendEmailWithCount: 'Send Email ({count})',
	noData: {
		title: 'No Equipment Check Reports',
		description: 'No relevant equipment check report data found'
	},
	reportCard: {
		coverAlt: 'Equipment Check Report Cover',
		author: 'Author',
		approver: 'Approver',
		updateTime: 'Update Time'
	},
	actions: {
		add: 'Add',
		generateReport: 'Generate Report',
		download: 'Download',
		modify: 'Modify',
		delete: 'Delete',
		sendEmail: 'Send Email',
		batchDelete: 'Batch Delete'
	},
	emailDialog: {
		title: 'Send Email',
		ccPerson: 'CC Person',
		selectCcPerson: 'Please select CC person',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		selectReportWarning: 'Please select equipment check report',
		selectCcPersonWarning: 'Please select CC person',
		sendSuccess: 'Sent successfully',
		deleteConfirm: 'Are you sure to delete the selected {count} items?',
		deleteSuccess: 'Deleted successfully',
		selectDeleteWarning: 'Please select records to delete',
		generateReportSuccess: 'Report generated successfully',
		operateSuccess: 'Operation successful',
		selectedCount: 'Selected {count} item(s)'
	},
	form: {
		fileName: 'Report Name',
		startTime: 'Start Time',
		endTime: 'End Time',
		reportTitle: 'Report Title',
		author: 'Author',
		approver: 'Approver',
		orgId: 'Department',
		result: 'Diagnostic Result',
		fileViewInDoc: 'View in document',
		equipmentCheckReport: 'Equipment Check Report',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		add: 'Add',
		update: 'Update',
		deviceName: 'Device Name',
		deviceParams: 'Device Parameters',
		paramName: 'Parameter Name',
		paramValue: 'Parameter Value',
		addParam: 'Add Parameter',
		reviewer: 'Reviewer',
		diagnosis: 'Diagnosis Analysis',
		advice: 'Maintenance Advice',
		sensorPicPath: 'Sensor Schematic',
		vibrationData: 'Condition Monitoring Data',
		sensorName: 'Sensor Name',
		vibrationH: 'Horizontal Vibration Velocity mm/s',
		vibrationV: 'Vertical Vibration Velocity mm/s',
		vibrationA: 'Axial Vibration Velocity mm/s',
		vibrationAcc: 'Vibration Acceleration m/s²',
		addSensorData: 'Add Sensor Data',
		attachment: 'Attachment Upload',
		uploadFile: 'Upload File',
		picturePreview: 'Preview Image'
	},
	table: {
		reportTitle: 'Report Title',
		equipmentCheckReport: 'Equipment Check Report',
		author: 'Author',
		approver: 'Approver',
		orgId: 'Department',
		result: 'Diagnostic Result',
		updateTime: 'Diagnostic Time'
	}
}
